import moment from 'moment';
import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { apiHolder, apis, util, } from 'api';
import ReadListIcons from '@web-common/components/UI/Icons/svgs/ReadListSvgs';
import { DEFAULT_REMINDER, initDefaultMoment, loopRules, reminderOpts } from '@web-schedule/components/CreateBox/util';
import { getCatalogList } from '@web-schedule/service';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import Alert from '@web-common/components/UI/Alert/Alert';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
import dayjs from 'dayjs';
import { FOLDER_TREE_MAX_COUNT, FLOLDER, MAIL_LIST_CHOOSE_TYPE, TASK_MAIL_STATUS, PIN_KEY, MAIL_TAG_SYSTEM_MAP, MAIL_TAG_QUERY_MAP, QUERY2MAIL_TAG_MAP, } from '@web-mail/common/constant';
import { getIn18Text } from 'api';
import { TongyongQiye, TongyongRenyuan2 } from '@sirius/icons';
const systemApi = apiHolder.api.getSystemApi();
const mailConfApi = apiHolder.api.requireLogicalApi(apis.mailConfApiImpl);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const inElectron = systemApi.isElectron();
const storeApi = apiHolder.api.getDataStoreApi();
export * from './utils/folder';
export * from './utils/mail';
export * from './utils/debounceRequest';
export const iconMap = new Map([
    [FLOLDER.DEFAULT, React.createElement(ReadListIcons.NewReceiveFolderSvg, null)],
    [FLOLDER.DRAFT, React.createElement(ReadListIcons.DraftFolderSvg, null)],
    [FLOLDER.SENT, React.createElement(ReadListIcons.SendFolderSvg, null)],
    [FLOLDER.DELETED, React.createElement(ReadListIcons.RecoverFolderSvg, null)],
    [FLOLDER.SPAM, React.createElement(ReadListIcons.JunkFolderSvg, null)],
    [FLOLDER.ADVITISE, React.createElement(ReadListIcons.AdFolderSvg, null)],
    [FLOLDER.WAITINGISSUE, React.createElement(ReadListIcons.UnverifyFolderSvg, null)],
    [FLOLDER.READYISSUE, React.createElement(ReadListIcons.VerifyFolderSvg, null)],
    [FLOLDER.REDFLAG, React.createElement(ReadListIcons.FlagFolderSvg, null)],
    [FLOLDER.TASK, React.createElement(ReadListIcons.TaskFolderSvg, null)],
    [FLOLDER.STAR, React.createElement(ReadListIcons.StartFolderSvg, null)],
    [FLOLDER.UNREAD, React.createElement(ReadListIcons.UnreadFolderSvg, null)],
    [FLOLDER.CUSTOMER_UNFOLLOW, React.createElement(TongyongQiye, { color: "#7d8085" })],
    [FLOLDER.UNFOLLOW, React.createElement(TongyongRenyuan2, { color: "#7d8085" })],
    [FLOLDER.ALL_RECEIVE, React.createElement(ReadListIcons.NewReceiveFolderSvg, null)],
    [FLOLDER.ALL_UNREAD, React.createElement(ReadListIcons.UnreadFolderSvg, null)],
    [FLOLDER.ALL_DRAFT, React.createElement(ReadListIcons.DraftFolderSvg, null)],
    [FLOLDER.ALL_SENT, React.createElement(ReadListIcons.SendFolderSvg, null)],
    [FLOLDER.ALL_REDFLAG, React.createElement(ReadListIcons.FlagFolderSvg, null)],
    [FLOLDER.ALL_CUSTOMER_UNFOLLOW, React.createElement(TongyongQiye, { color: "#7d8085" })],
    [FLOLDER.ALL_UNFOLLOW, React.createElement(TongyongRenyuan2, { color: "#7d8085" })],
]);
export const formatTime = (time) => {
    if (!time)
        return '';
    const timeZone = mailConfApi.getTimezone();
    const _time = new Date(systemApi.getDateByTimeZone(time, timeZone, true));
    const _now = new Date(systemApi.getDateByTimeZone(new Date(), timeZone));
    const _year = _time.getFullYear();
    const _month = _time.getMonth();
    const _day = _time.getDate();
    const _hour = _time.getHours();
    const _minutes = _time.getMinutes();
    if (_year === _now.getFullYear()) {
        if (_time.toDateString() === _now.toDateString()) {
            if (_now.getTime() - _time.getTime() <= 180000) {
                return getIn18Text('GANGGANG');
            }
            return `${_hour}:${_minutes < 10 ? `0${_minutes}` : _minutes}`;
        }
        if (_now.setHours(0, 0, 0, 0) - _time.setHours(0, 0, 0, 0) == 86400000) {
            return getIn18Text('ZUOTIAN');
        }
        return `${_month + 1}${getIn18Text('yue2')}${_day}${getIn18Text('ri')}`;
    }
    return `${_year}${getIn18Text('nian2')}${_month + 1}${getIn18Text('yue2')}${_day}${getIn18Text('ri')}`;
};
export const formatDigitalTime = time => {
    if (!time)
        return '';
    const timeZone = mailConfApi.getTimezone();
    const _time = new Date(systemApi.getDateByTimeZone(time, timeZone, true));
    const _now = new Date(systemApi.getDateByTimeZone(new Date(), timeZone));
    const _year = _time.getFullYear();
    const _month = _time.getMonth();
    const _day = _time.getDate();
    const _hour = _time.getHours();
    const _minutes = _time.getMinutes();
    const timeGap = _now.getTime() - _time.getTime();
    if (timeGap < 0) {
        if (_year === _now.getFullYear()) {
            return `${_month < 9 ? `0${_month + 1}` : _month + 1}-${_day < 10 ? `0${_day}` : _day}`;
        }
        return `${_year}-${_month < 9 ? `0${_month + 1}` : _month + 1}-${_day < 10 ? `0${_day}` : _day}`;
    }
    if (_year === _now.getFullYear()) {
        if (_time.toDateString() === _now.toDateString()) {
            if (timeGap <= 180000) {
                return getIn18Text('GANGGANG');
            }
            return `${_hour < 10 ? `0${_hour}` : _hour}:${_minutes < 10 ? `0${_minutes}` : _minutes}`;
        }
        if (_now.setHours(0, 0, 0, 0) - _time.setHours(0, 0, 0, 0) == 86400000) {
            return getIn18Text('ZUOTIAN');
        }
        return `${_month < 9 ? `0${_month + 1}` : _month + 1}-${_day < 10 ? `0${_day}` : _day}`;
    }
    return `${_year}-${_month < 9 ? `0${_month + 1}` : _month + 1}-${_day < 10 ? `0${_day}` : _day}`;
};
export const formatTimeWithHM = (time, showText = true) => {
    if (!time)
        return '';
    const timeZone = mailConfApi.getTimezone();
    const _time = new Date(systemApi.getDateByTimeZone(time, timeZone, true));
    const _now = new Date(systemApi.getDateByTimeZone(new Date(), timeZone));
    const _year = _time.getFullYear();
    const _month = _time.getMonth() + 1;
    const _month1 = _month < 10 ? `0${_month}` : _month;
    const _day = _time.getDate();
    const _day1 = _day < 10 ? `0${_day}` : _day;
    const _hour = _time.getHours();
    const _minutes = _time.getMinutes();
    const HM = `${_hour}:${_minutes < 10 ? `0${_minutes}` : _minutes}`;
    const timeGap = _now.getTime() - _time.getTime();
    if (timeGap < 0) {
        if (_year === _now.getFullYear()) {
            return `${_month1}/${_day1} ${HM}`;
        }
        return `${_year}/${_month1}/${_day1} ${HM}`;
    }
    if (_year === _now.getFullYear()) {
        if (_time.toDateString() === _now.toDateString() && showText) {
            if (timeGap <= 180000) {
                return getIn18Text('GANGGANG');
            }
            return HM;
        }
        if (_now.setHours(0, 0, 0, 0) - _time.setHours(0, 0, 0, 0) == 86400000 && showText) {
            return getIn18Text('ZUOTIAN') + ' ' + HM;
        }
        return `${_month1}/${_day1} ${HM}`;
    }
    return `${_year}/${_month1}/${_day1} ${HM}`;
};
export const formatTimeWithHMSimple = (time) => {
    if (!time)
        return '';
    const timeZone = mailConfApi.getTimezone();
    const _time = new Date(systemApi.getDateByTimeZone(time, timeZone, true));
    const _now = new Date(systemApi.getDateByTimeZone(new Date(), timeZone));
    const _year = _time.getFullYear();
    const _month = _time.getMonth() + 1;
    const _month1 = _month < 10 ? `0${_month}` : _month;
    const _day = _time.getDate();
    const _day1 = _day < 10 ? `0${_day}` : _day;
    const _hour = _time.getHours();
    const _minutes = _time.getMinutes();
    const HM = `${_hour}:${_minutes < 10 ? `0${_minutes}` : _minutes}`;
    if (_year === _now.getFullYear()) {
        return `${_month1}/${_day1} ${HM}`;
    }
    return `${_year}/${_month1}/${_day1} ${HM}`;
};
export const scheduleSendFormatTime = (time) => {
    if (!time)
        return '';
    let timeZone = mailConfApi.getTimezone();
    const useLocalTimeZone = mailConfApi.getLocalTimezone();
    if (useLocalTimeZone) {
        timeZone = -new Date().getTimezoneOffset() / 60;
    }
    const _time = new Date(systemApi.getDateByTimeZone(time, timeZone, true));
    const _now = new Date(systemApi.getDateByTimeZone(new Date(), timeZone));
    const _year = _time.getFullYear();
    const _month = _time.getMonth();
    const _day = _time.getDate();
    const _hour = _time.getHours();
    const _minutes = _time.getMinutes();
    if (_year === _now.getFullYear()) {
        if (_time.toDateString() === _now.toDateString()) {
            if (_now.getTime() - _time.getTime() <= 180000) {
                return getIn18Text('GANGGANG');
            }
            return `${_hour < 10 ? `0${_hour}` : _hour}:${_minutes < 10 ? `0${_minutes}` : _minutes}`;
        }
        if (_now.setHours(0, 0, 0, 0) - _time.setHours(0, 0, 0, 0) == 86400000) {
            return getIn18Text('ZUOTIAN');
        }
        return `${_month < 9 ? `0${_month + 1}` : _month + 1}-${_day < 10 ? `0${_day}` : _day}`;
    }
    return `${_year}-${_month < 9 ? `0${_month + 1}` : _month + 1}-${_day < 10 ? `0${_day}` : _day}`;
};
export const isScheduleSend = item => {
    var _a, _b, _c;
    if (!((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.sendTime) || !((_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.receiveTime)) {
        return false;
    }
    return moment((_c = item === null || item === void 0 ? void 0 : item.entry) === null || _c === void 0 ? void 0 : _c.sendTime).unix() > moment(item.entry.receiveTime).unix() && moment(item.entry.sendTime).unix() > moment().unix() && item.entry.folder === 2;
};
export const dateFormat = (fmt, dateParam, useServerTimeZone = true) => {
    let ret;
    let timeZone = mailConfApi.getTimezone();
    let date = new Date(systemApi.getDateByTimeZone(dateParam, timeZone, useServerTimeZone));
    if (date.getFullYear().toString() === 'NaN') {
        date = new Date(dayjs(dateParam).valueOf());
    }
    const opt = {
        'Y+': date.getFullYear().toString(),
        'm+': (date.getMonth() + 1).toString(),
        'd+': date.getDate().toString(),
        'H+': date.getHours().toString(),
        'M+': date.getMinutes().toString(),
        'S+': date.getSeconds().toString(),
    };
    for (const k in opt) {
        ret = new RegExp(`(${k})`).exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
    }
    return fmt;
};
export const getWeekdayText = (date) => {
    const weekday = date.getDay();
    const WeekdayText = [
        getIn18Text('XINGQIRI'),
        getIn18Text('XINGQIYI'),
        getIn18Text('XINGQIER'),
        getIn18Text('XINGQISAN'),
        getIn18Text('XINGQISI'),
        getIn18Text('XINGQIWU'),
        getIn18Text('XINGQILIU'),
    ];
    return WeekdayText[weekday] || '';
};
const READ_STR = getIn18Text('EMAIL_READ_STATUS_READ');
const RECEIVE_STR = getIn18Text('EMAIL_READ_STATUS_SERVER_RECEIVE');
const NO_RECEIVE_STR = getIn18Text('EMAIL_READ_STATUS_SERVER_NO_RECEIVE');
const REJECTED_STR = getIn18Text('EMAIL_READ_STATUS_REJECTED');
const SENDING_STR = getIn18Text('EMAIL_READ_STATUS_SENDING');
const REJECTED_BY_SERVER_STR = getIn18Text('MAIL_READ_STATUS_REJECTED_BY_SERVER');
const REVIEWING_STR = getIn18Text('MAIL_READ_STATUS_REVIEWING');
const UNAPPROVED_STR = getIn18Text('MAIL_READ_STATUS_UNAPPROVED');
export const readState = {
    109: { status: 'read', text: READ_STR, color: '#5FC375' },
    100: { status: 'unread', text: RECEIVE_STR },
    106: { status: 'unread', text: RECEIVE_STR },
    107: { status: 'unread', text: RECEIVE_STR },
    108: { status: 'unread', text: RECEIVE_STR },
    110: { status: 'unread', text: RECEIVE_STR },
    102: { status: 'unread', text: NO_RECEIVE_STR },
    105: { status: 'unread', text: NO_RECEIVE_STR },
    103: { status: 'unread', text: REJECTED_STR, color: '#F74F4F' },
    104: { status: 'unread', text: REJECTED_STR, color: '#F74F4F' },
    101: { status: 'unkown', text: SENDING_STR },
    201: { status: 'unkown', text: SENDING_STR },
    200: { status: 'unread', text: RECEIVE_STR },
    206: { status: 'unread', text: RECEIVE_STR },
    207: { status: 'unread', text: RECEIVE_STR },
    208: { status: 'unread', text: RECEIVE_STR },
    202: { status: 'unkown', text: NO_RECEIVE_STR },
    205: { status: 'unkown', text: NO_RECEIVE_STR },
    203: { status: 'unkown', text: REJECTED_BY_SERVER_STR, color: '#F74F4F' },
    204: { status: 'unkown', text: REJECTED_BY_SERVER_STR, color: '#F74F4F' },
    601: { status: 'unkown', text: REVIEWING_STR },
    602: { status: 'unkown', text: UNAPPROVED_STR, color: '#F74F4F' },
    604: { status: 'unkown', text: UNAPPROVED_STR, color: '#F74F4F' },
};
export const rclStatus = {
    0: getIn18Text('ZHENGZAICHEHUIYOU'),
    4: getIn18Text('XINJIANBUCUNZAI'),
    5: getIn18Text('MAIL_RECALL_FAIL_BY_READ'),
    6: getIn18Text('XINJIANCUNZAIDAN'),
    7: getIn18Text('XINJIANCUNZAI，'),
    8: getIn18Text('XINJIANYIGUOQI'),
    9: getIn18Text('BUZHICHICHEHUI'),
    14: getIn18Text('SHOUXINYONGHUBU'),
    15: getIn18Text('XITONGCHUCUO'),
};
export const formatReadStatus = data => {
    var _a;
    const rclList = [];
    const readList = [];
    const returnData = {
        isrcl: false,
        data: [],
    };
    data.map(item => {
        if (item.result >= 700) {
            if (item.result == 700 || item.result == 800) {
                item.status = 'suc';
                item.text = '';
                item.color = '#5FC375';
            }
            else if (item.result == 709) {
                item.status = 'fail';
                item.text = rclStatus[item.rclResult];
                item.color = '#F74F4F';
            }
            rclList.push(item);
        }
        else {
            const setting = readState[item.result];
            if (setting) {
                item.status = setting.status;
                item.text = setting.text;
                item.color = setting.color;
            }
            readList.push(item);
        }
    });
    returnData.tid = (_a = data[0]) === null || _a === void 0 ? void 0 : _a.tid;
    if (rclList.length) {
        returnData.isrcl = true;
        returnData.data = rclList;
    }
    else {
        returnData.data = readList;
    }
    return returnData;
};
export const getPositionForTextArea = ctrl => {
    const CaretPos = {
        start: 0,
        end: 0,
    };
    if (ctrl.selectionStart) {
        CaretPos.start = ctrl.selectionStart;
    }
    if (ctrl.selectionEnd) {
        CaretPos.end = ctrl.selectionEnd;
    }
    return CaretPos;
};
export const setCursorPosition = (ctrl, pos) => {
    ctrl.focus();
    ctrl.setSelectionRange(pos, pos);
};
let cachedFirstCatalog;
export const conferenceInit = async () => {
    if (cachedFirstCatalog === undefined) {
        const list = await getCatalogList(false, false);
        const [firstCatalog] = list;
        cachedFirstCatalog = firstCatalog;
    }
    return {
        catalogId: cachedFirstCatalog === null || cachedFirstCatalog === void 0 ? void 0 : cachedFirstCatalog.id,
        color: cachedFirstCatalog === null || cachedFirstCatalog === void 0 ? void 0 : cachedFirstCatalog.color,
        enmuRecurrenceRule: loopRules[0].value,
        enmuReminders: reminderOpts(false)[0].value,
        reminders: DEFAULT_REMINDER,
        location: '',
        meetingOrderParam: undefined,
        time: {
            allDay: false,
        },
        moments: Object.assign({}, initDefaultMoment()),
    };
};
export const advancedSearchFolderData2Tree = (data) => {
    var _a, _b;
    const treeNode = {
        key: data.entry.mailBoxId,
        title: data.entry.mailBoxName,
        isLeaf: !((_a = data.children) === null || _a === void 0 ? void 0 : _a.length),
        icon: iconMap.get((_b = data.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId) || React.createElement(ReadListIcons.FolderSvg, null),
        value: data.entry.mailBoxId,
    };
    if (!treeNode.isLeaf && data.children && data.children.length > 0) {
        treeNode.children = data.children.map(advancedSearchFolderData2Tree);
    }
    return treeNode;
};
export const buildSearchString = form => {
    const str = [];
    if (form.from) {
        str.push(`发件人:${form.from}`);
    }
    if (form.to) {
        str.push(`收件人:${form.to}`);
    }
    if (form.memo) {
        str.push(`邮件备注:${form.memo}`);
    }
    if (form.subject) {
        str.push(`邮件主题:${form.subject}`);
    }
    if (form.content) {
        str.push(`邮件正文:${form.content}`);
    }
    if (form.fids) {
        str.push(`文件夹:${form.fids}`);
    }
    if (form.start || form.end) {
        const start = form.start && moment.isMoment(form.start) ? form.start.format('YYYY-MM-DD') : '';
        const end = form.end && moment.isMoment(form.end) ? form.end.format('YYYY-MM-DD') : '';
        str.push(`时间范围:${start}:${end}`);
    }
    if (form.attach) {
        str.push(`附件:${form.attach === 1 ? '仅含附件' : '不含附件'}`);
    }
    if (form.redFlag) {
        str.push('红旗:红旗邮件');
    }
    if (form.tag) {
        str.push('标签:' + form.tag);
    }
    if (form.account) {
        str.push(`搜索邮箱:${form.account}`);
    }
    return str.join('，');
};
export const buildSearchString_sd_more = (form) => {
    const { defalutFromList, defaultToList, subjects, contents, attachments, start, end, attach } = form;
    const str = [];
    if (defalutFromList === null || defalutFromList === void 0 ? void 0 : defalutFromList.email) {
        str.push(`发件人:${defalutFromList === null || defalutFromList === void 0 ? void 0 : defalutFromList.email}`);
    }
    const toList = defaultToList.filter((to) => !!(to === null || to === void 0 ? void 0 : to.email));
    if (toList && toList.length) {
        str.push(`收件人:${toList.map((to) => to === null || to === void 0 ? void 0 : to.email).join('，')}`);
    }
    if (subjects && subjects.some(Boolean)) {
        str.push(`邮件主题:${subjects.filter(Boolean).join('，')}`);
    }
    if (contents && contents.some(Boolean)) {
        str.push(`邮件正文:${contents.filter(Boolean).join('，')}`);
    }
    if (attachments && attachments.some(Boolean)) {
        str.push(`附件名称:${attachments.filter(Boolean).join('，')}`);
    }
    if (start || end) {
        str.push(`时间范围:${start || '_'}:${end || '_'}`);
    }
    if (!!attach) {
        str.push(`附件:${form.attach === 1 ? '仅含附件' : '不含附件'}`);
    }
    return str.join('；');
};
export const advancedSearchEnable = (form) => {
    let enable = false;
    for (const key in form) {
        if (Object.prototype.hasOwnProperty.call(form, key)) {
            const element = form[key];
            const keys = ['from', 'to', 'subject', 'content', 'start', 'end'];
            if (keys.includes(key)) {
                enable = enable || !!element;
            }
        }
    }
    return enable;
};
export const advancedSearchEnable_sd = (form) => {
    let enable = false;
    for (const key in form) {
        if (Object.prototype.hasOwnProperty.call(form, key)) {
            const element = form[key];
            if (key !== 'operator') {
                enable = enable || !!element;
            }
        }
    }
    return enable;
};
export const getFolderNameById = (id, data) => {
    let name = '';
    for (let index = 0; index < data.length; index++) {
        const el = data[index];
        if (el.mailBoxId === id || el.entry.mailBoxId === id) {
            name = el.entry.mailBoxName;
            break;
        }
        if (el.children && el.children.length > 0) {
            name = getFolderNameById(id, el.children);
        }
    }
    return name;
};
const ReplaceDFSHelper = (node, callback, extraInfo = { deep: 0, path: [] }, childrenName = 'children') => {
    const { deep = 0, path = [] } = extraInfo;
    let packageNode = callback &&
        callback(node, {
            deep: deep + 1,
            path: [...path, node],
        });
    packageNode = packageNode === undefined ? node : packageNode;
    if (packageNode && packageNode[childrenName] && packageNode[childrenName].length) {
        packageNode[childrenName] = treeReplaceDFS(packageNode[childrenName], callback, {
            deep: deep + 1,
            path: [...path, packageNode],
        });
    }
    return packageNode;
};
export const treeReplaceDFS = (tree, callback, extraInfo) => {
    const _tree = Array.isArray(tree) ? tree : [tree];
    if (_tree) {
        const res = _tree.map(node => ReplaceDFSHelper(node, callback, extraInfo)).filter(node => node);
        return Array.isArray(tree) ? res : res[0];
    }
    return null;
};
const DFSHelper = (node, callback, extraInfo = { deep: 0, path: [] }, childrenName = 'children') => {
    const { deep = 0, path = [] } = extraInfo;
    callback(node, {
        deep: deep + 1,
        path: [...path, node],
    });
    if (node && node[childrenName] && node[childrenName].length) {
        treeDFS(node[childrenName], callback, {
            deep: deep + 1,
            path: [...path, node],
        });
    }
};
export const treeDFS = (tree, callback, extraInfo) => {
    const _tree = Array.isArray(tree) ? tree : [tree];
    if (_tree) {
        _tree.forEach(node => {
            DFSHelper(node, callback, extraInfo);
        });
    }
};
export const getTreeNodeByKey = (key, tree) => {
    let findNode;
    treeDFS(tree, (node) => {
        if (node.key === key) {
            findNode = node;
        }
    });
    return findNode;
};
export const operCheck = (tree, node) => {
    if (node._deep && node._deep > 12) {
        Message.warn({
            content: getIn18Text('ZUIDUOXINJIAN'),
        });
        return false;
    }
    return true;
};
export const getTreeId2Node = (tree) => {
    const map = {};
    treeDFS(tree, item => {
        var _a;
        map[(_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId] = item;
    });
    return map;
};
export const getMailFolderTreeList = (mailFolderTreeList, { id, parent, sorts }) => {
    var _a, _b;
    const node = getTreeNodeById(mailFolderTreeList, id);
    const parentNode = getTreeNodeById(mailFolderTreeList, parent);
    const parentNodeOld = getParentNodeById(mailFolderTreeList, id);
    const pidOld = ((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.pid) || 0;
    if (parentNode) {
        parentNode.children = sorts.map(id => getTreeNodeById(mailFolderTreeList, id) || null).filter(f => f !== null);
        parentNode.childrenCount = parentNode.children.length;
    }
    else if (parent === 0) {
        mailFolderTreeList = sorts.map(id => getTreeNodeById(mailFolderTreeList, id) || null).filter(f => f !== null);
    }
    if (pidOld !== parent) {
        if (parentNodeOld && parentNodeOld.children) {
            parentNodeOld.children = parentNodeOld === null || parentNodeOld === void 0 ? void 0 : parentNodeOld.children.filter(f => f.entry.mailBoxId !== id);
            parentNodeOld.childrenCount = parentNodeOld.children.length;
        }
        else {
            mailFolderTreeList = mailFolderTreeList.filter(f => f.entry.mailBoxId !== id);
        }
    }
    if (node) {
        node.entry.pid = parent;
        node.entry.mailBoxParent = parent;
        updateNodeDeep(node, ((_b = parentNode === null || parentNode === void 0 ? void 0 : parentNode.entry) === null || _b === void 0 ? void 0 : _b._deep) || 0);
    }
    return mailFolderTreeList;
};
const updateNodeDeep = (node, deep) => {
    if (node) {
        node.entry._deep = deep + 1;
        if (node.children) {
            node.children.forEach(item => {
                updateNodeDeep(item, deep + 1);
            });
        }
    }
};
export const getTreeNodeById = (tree, id) => {
    let res = null;
    treeDFS(tree, node => {
        if (node.entry.mailBoxId == id) {
            res = node;
        }
    });
    return res;
};
export const getParentNodeById = (tree, id) => {
    const node = getTreeNodeById(tree, id);
    let parentNode = null;
    if (node) {
        const { pid } = node.entry;
        if (pid != null) {
            parentNode = getTreeNodeById(tree, pid);
        }
    }
    return parentNode;
};
export const getTreeIdPathById = (tree, id) => {
    let pathList = [];
    if (tree) {
        treeDFS(tree, (node, { path }) => {
            if (node.entry.mailBoxId == id) {
                pathList = path.map(item => item.entry.mailBoxId);
            }
        });
    }
    return [...new Set(pathList)];
};
export const getChildTreeByRule = (tree, ruleFn) => {
    const _tree = cloneDeep(tree);
    if (_tree && ruleFn != null) {
        return treeReplaceDFS(_tree, (node) => (ruleFn(node) ? node : null));
    }
    return _tree;
};
export const SEARCH_RESULT_STATS_ORDER = ['fromAddress', 'sentDate', 'flags.attached', 'flags.read'];
export const getNoRepeatFolderName = (tree, parentId, name, nodeId) => {
    const parentNode = getTreeNodeById(tree, parentId);
    let folderName = name;
    if (parentNode && parentNode.children) {
        const brotherNodes = parentNode.children;
        const brotherNamesMap = {};
        brotherNodes.forEach(item => {
            if (nodeId !== item.entry.mailBoxId) {
                brotherNamesMap[item.entry.mailBoxName.toLowerCase()] = true;
            }
        });
        while (brotherNamesMap[folderName]) {
            folderName += '-1';
        }
    }
    return folderName;
};
export const getNoRepeatFolderNameByMumber = (tree, parentId, name, nodeId) => {
    const parentNode = getTreeNodeById(tree, parentId);
    let folderName = name;
    if (parentNode && parentNode.children) {
        const brotherNodes = parentNode.children;
        const brotherNamesMap = {};
        brotherNodes.forEach(item => {
            if (nodeId !== item.entry.mailBoxId) {
                brotherNamesMap[item.entry.mailBoxName.toLowerCase()] = true;
            }
        });
        let index = 0;
        while (true) {
            if (!brotherNamesMap[folderName + (index ? index.toString() : '')]) {
                folderName += index ? index.toString() : '';
                break;
            }
            index += 1;
        }
    }
    return folderName;
};
export async function sleep(time) {
    return new Promise(r => {
        setTimeout(r, time);
    });
}
const debouceWarn = debounce(params => {
    Message.warn(params);
}, 1000);
export const folderNameValidate = value => {
    const folderName = value.trim();
    const folderNameReg = /[,%'\\"?;<>&*\|]/;
    let hasForbidChar = false;
    try {
        hasForbidChar = folderNameReg.test(folderName);
    }
    catch (e) {
        console.warn('folderNameValidate', 'reg error');
    }
    if (folderName == null || folderName.length <= 0) {
        Message.warn({
            content: getIn18Text('WENJIANJIAMINGCHENG'),
        });
        return false;
    }
    if (folderName.length > 40) {
        debouceWarn({ content: getIn18Text('MINGCHENGZUIDUOSHU'), duration: 1, key: 'folderNameValidate' });
        return false;
    }
    if (hasForbidChar) {
        debouceWarn({ content: getIn18Text('MINGCHENGBUNENGBAO'), duration: 1, key: 'folderNameValidate' });
        return false;
    }
    return true;
};
export function getCorpMessageIdsByMailItem(item) {
    const ids = [];
    const { isThread } = item;
    const { threadMessageIds } = item.entry;
    if (isThread && threadMessageIds && threadMessageIds.length) {
        ids.push(...threadMessageIds);
    }
    else {
        ids.push(item.entry.id);
    }
    return ids;
}
export function getFolderErrorMsg(resError) {
    const msg = resError.message;
    if (typeof msg === 'string' && msg.length && !/^[A-Za-z_\d]*$/.test(msg)) {
        return msg;
    }
    if (msg === 'FA_NAME_EXISTS') {
        return getIn18Text('REPEATFOLDERNAME');
    }
    if (msg === 'FA_THIRD_FOLDER_NOT_CREATED') {
        return getIn18Text('NOCREATEONSERVE');
    }
    return '';
}
export function isMac() {
    return window.navigator.userAgent.toLocaleLowerCase().includes('mac os');
}
export const validateFolderTreeCount = (tree) => {
    let sum = 0;
    treeDFS(tree, () => {
        sum += 1;
    });
    if (sum > FOLDER_TREE_MAX_COUNT) {
        Message.warn({
            content: getIn18Text('ZUIDUOXINJIAN1'),
        });
        return false;
    }
    return true;
};
export const folderAddOperCheck = (tree, node) => {
    var _a, _b;
    if (node && ((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a._deep) && ((_b = node === null || node === void 0 ? void 0 : node.entry) === null || _b === void 0 ? void 0 : _b._deep) > 12) {
        Message.warn({
            content: getIn18Text('ZUIDUOXINJIAN'),
        });
        return false;
    }
    return true;
};
export const scanMailsSetTimeGradients = (mails, fromIndex, isCheckable = true) => {
    const scanStartIndex = fromIndex || 0;
    if (scanStartIndex >= mails.length)
        return null;
    let curWeekDay = dayjs().day();
    curWeekDay = curWeekDay === 0 ? 7 : curWeekDay;
    const curMonth = dayjs().month() + 1;
    const fixedTimeGradients = [
        {
            name: 'today',
            nameText: getIn18Text('JINTIAN'),
            start: dayjs().startOf('date'),
            end: dayjs().endOf('date'),
        },
        {
            name: 'yesterday',
            nameText: getIn18Text('ZUOTIAN'),
            start: dayjs().subtract(1, 'day').startOf('date'),
            end: dayjs().subtract(1, 'day').endOf('date'),
        },
        {
            name: 'curWeekRest',
            nameText: getIn18Text('BENZHOU'),
            start: dayjs()
                .subtract(curWeekDay - 1, 'day')
                .startOf('date'),
            end: dayjs()
                .add(7 - curWeekDay, 'day')
                .endOf('date'),
        },
        {
            name: 'curMonthRest',
            nameText: getIn18Text('formatter_month', { month: curMonth }),
            start: dayjs().startOf('month'),
            end: dayjs().endOf('month'),
        },
    ];
    let fixedTimeGradientsIndex = 0;
    let curTimeGradientScope = null;
    const timeHashes = [];
    const calcuteGradient = (curTimeDJ, idx, prevIndex) => {
        curTimeGradientScope = {
            start: curTimeDJ.startOf('month'),
            end: curTimeDJ,
        };
        const curGradientYear = curTimeDJ.year();
        const curGradientMonth = curTimeDJ.month() + 1;
        const curGradientText = curGradientYear === dayjs().year()
            ? getIn18Text('formatter_month', { month: curGradientMonth })
            : getIn18Text('formatter_month_year', { date: curTimeDJ.valueOf() });
        return {
            key: curGradientText,
            content: curGradientText,
            isFoldable: true,
            isCheckable: isCheckable,
            index: idx,
            height: 27 + 9,
            position: 'top',
            fixed: {
                height: 27 + 5,
            },
        };
    };
    const findAndSetGradient = (curTimeDJ, idx, prevIndex) => {
        while (fixedTimeGradientsIndex <= 3) {
            const curGradientScope = fixedTimeGradients[fixedTimeGradientsIndex];
            if (curGradientScope && curTimeDJ.isBefore(curGradientScope.end) && curTimeDJ.isAfter(curGradientScope.start)) {
                curTimeGradientScope = curGradientScope;
                return {
                    key: (curTimeGradientScope === null || curTimeGradientScope === void 0 ? void 0 : curTimeGradientScope.nameText) || '',
                    content: curTimeGradientScope.nameText,
                    isFoldable: true,
                    isCheckable: isCheckable,
                    index: idx,
                    height: 27 + 9,
                    position: 'top',
                    fixed: {
                        height: 27 + 5,
                    },
                };
            }
            fixedTimeGradientsIndex += 1;
        }
        return calcuteGradient(curTimeDJ, idx, prevIndex);
    };
    let prevIndex = scanStartIndex;
    let preKey = '';
    const key2CountMap = {};
    for (let i = scanStartIndex; i < mails.length; i++) {
        const mail = mails[i];
        const { entry } = mail;
        const { sendTime } = entry;
        const sendTimeDJ = dayjs(sendTime);
        if (!curTimeGradientScope) {
            const res = findAndSetGradient(sendTimeDJ, i, prevIndex);
            if (res) {
                timeHashes.push(res);
                key2CountMap[preKey] = i - prevIndex;
                prevIndex = i;
                preKey = res.key;
            }
        }
        else if (sendTimeDJ.isBefore(curTimeGradientScope.start)) {
            const res = findAndSetGradient(sendTimeDJ, i, prevIndex);
            if (res) {
                timeHashes.push(res);
                key2CountMap[preKey] = i - prevIndex;
                prevIndex = i;
                preKey = res.key;
            }
        }
    }
    if (preKey && key2CountMap[preKey] == null) {
        key2CountMap[preKey] = mails.length - prevIndex;
    }
    timeHashes.forEach(item => {
        const count = key2CountMap[item.key];
        if (count != null) {
            item.content = `${item.key} ${count > 0 ? count + getIn18Text('FENGMAIL') : ''}`;
        }
    });
    return timeHashes;
};
export const setCurrentAccount = (mail) => {
    mail
        ? accountApi.setCurrentAccount({
            email: mail,
        })
        : accountApi.setCurrentAccount();
};
export const isMainAccount = (accountName) => {
    const currentUser = systemApi.getCurrentUser();
    if (accountName == '' || accountName == null) {
        return true;
    }
    if (currentUser && accountName) {
        return currentUser.id === accountName;
    }
    return false;
};
export const isAliasAccount = (accountName) => {
    var _a;
    const currentUser = systemApi.getCurrentUser();
    if (!currentUser) {
        return false;
    }
    const id = currentUser.id;
    const aliasList = ((_a = currentUser.prop) === null || _a === void 0 ? void 0 : _a.accountAlias) || [];
    const aliasHasMain = aliasList.includes(id);
    const accountNotMain = accountName !== id;
    const accountInAlias = aliasList.includes(accountName || '');
    return aliasHasMain && accountNotMain && accountInAlias;
};
export const proxyImg = (params) => {
    const isElectron = systemApi.isElectron();
    const { fileUrl, _token, isSubAccount } = params;
    let imgSrc = fileUrl;
    if (isSubAccount && !isElectron) {
        const newUrl = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.replace(/(\/js6\/s)/, '/commonweb/proxy$1');
        imgSrc = `${newUrl}&_token=${_token}`;
    }
    return imgSrc;
};
export const getMapConfigBySameAccountKey = (map, accountId) => {
    if (map && accountId) {
        const accountInfo = accountApi.getSubAccountInfo(accountId);
        if (accountInfo) {
            if ((accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.agentEmail) && map[accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.agentEmail]) {
                return map[accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.agentEmail];
            }
            if ((accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountEmail) && map[accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountEmail]) {
                return map[accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.accountEmail];
            }
            if ((accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.id) && map[accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.id]) {
                return map[accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.id];
            }
        }
        if (map[accountId]) {
            return map[accountId];
        }
    }
    return null;
};
export const getTreeStatesByAccount = (map, accountId) => {
    if (map) {
        if (accountId && !isMainAccount(accountId)) {
            return getMapConfigBySameAccountKey(map, accountId);
        }
        return map.main;
    }
    return null;
};
export const aggregateFolderIds = (mailbox) => {
    try {
        const ids = [];
        const currentId = mailbox.entry.mailBoxId;
        if (currentId) {
            ids.push(currentId);
        }
        if (mailbox.children && mailbox.children.length > 0) {
            mailbox.children.forEach(item => {
                ids.push(...aggregateFolderIds(item));
            });
        }
        return ids;
    }
    catch (e) {
        console.error('aggregateFolderIds error');
        return [];
    }
};
export const getMainAccount = () => { var _a; return ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || ''; };
export const formatNumberByMax = (sum, max) => {
    if (max) {
        if (sum < max) {
            return sum + '';
        }
        else {
            return max + '+';
        }
    }
    return sum + '';
};
export const tpMailAttConfig = {
    hidePackDownload: systemApi.inEdm() && !systemApi.isElectron(),
    hideCloudPreview: false,
    hideChatOpenFile: false,
    hideChatOpenDir: false,
    hideActionOperate: false,
    hideMoreOperate: false,
    hideSaveForward: true,
};
export const edmReplyMailAttConfig = {
    hidePackDownload: true,
    hideCloudPreview: true,
    hideChatOpenFile: true,
    hideChatOpenDir: true,
    hideActionOperate: true,
    hideMoreOperate: true,
    hideSaveForward: true,
};
export const bizMailAttConfig = {
    hidePackDownload: systemApi.inEdm() && !systemApi.isElectron(),
    hideCloudPreview: true,
    hideChatOpenFile: false,
    hideChatOpenDir: true,
    hideActionOperate: true,
    hideMoreOperate: false,
    hideSaveForward: true,
};
export const isValidArray = (array) => Array.isArray(array) && array.length > 0;
export const dragTransFileHasEml = (event) => {
    var _a, _b, _c;
    const fileList = (_a = event === null || event === void 0 ? void 0 : event.dataTransfer) === null || _a === void 0 ? void 0 : _a.items;
    let hasEml = false;
    try {
        if (fileList) {
            for (let i = 0; i < fileList.length; i++) {
                if (((_b = fileList[i]) === null || _b === void 0 ? void 0 : _b.type) && ((_c = fileList[i]) === null || _c === void 0 ? void 0 : _c.type.includes('rfc822'))) {
                    hasEml = true;
                    break;
                }
            }
        }
    }
    catch (e) {
        console.error('[Error]: : dragTransFileHasEml', e);
    }
    return hasEml;
};
export const getEmlFileFromDragTrans = (event) => {
    var _a, _b, _c;
    const fileList = (_a = event === null || event === void 0 ? void 0 : event.dataTransfer) === null || _a === void 0 ? void 0 : _a.items;
    const uploadFileList = [];
    try {
        if (fileList) {
            for (let i = 0; i < fileList.length; i++) {
                if (((_b = fileList[i]) === null || _b === void 0 ? void 0 : _b.type) && ((_c = fileList[i]) === null || _c === void 0 ? void 0 : _c.type.includes('rfc822'))) {
                    const inputFile = fileList[i].getAsFile && fileList[i].getAsFile();
                    if (inputFile) {
                        uploadFileList.push(inputFile);
                    }
                }
            }
        }
    }
    catch (e) {
        console.error('[Error]: : getEmlFromDragTrans', e);
    }
    return uploadFileList;
};
export const importMails = (conf, useWebImport) => {
    const hideLoading = Message.loading({ content: getIn18Text('ZHENGZAIDAORUYOUJIAN') });
    return mailApi.doImportMails(conf, useWebImport).then((importResult) => {
        let successCount = 0, failedCount = 0;
        const isCanceled = importResult.some(impRes => !impRes.success && impRes.reason === 'canceled');
        if (isCanceled) {
            return;
        }
        const failedReasons = [];
        const pushReason = (raw) => {
            if (!raw) {
                failedReasons.push(getIn18Text('QITAYUANYIN'));
                return;
            }
            let text = '' + raw;
            try {
                const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
                if (obj) {
                    if (obj.reason && typeof obj.reason === 'string') {
                        text = obj.reason;
                    }
                    else if (obj.message && typeof obj.message === 'string') {
                        text = obj.message;
                    }
                    else if (obj.title && typeof obj.title === 'string') {
                        text = obj.title;
                    }
                }
            }
            catch (_e) {
            }
            if (text.includes('network repeat')) {
                failedReasons.push(getIn18Text('YICHUNZAIYOUXIANG'));
            }
            else if (text.includes('local repeat')) {
                failedReasons.push(getIn18Text('LOCAL_REPEAT'));
            }
            else if (text.includes('获取md5报错')) {
                failedReasons.push(getIn18Text('GET_MD5_ERROR'));
            }
            else if (text.includes('can not find dir or files')) {
                failedReasons.push(getIn18Text('DIR_NOT_FOUND'));
            }
            else if (text.includes('upload failed')) {
                failedReasons.push(getIn18Text('UPLOAD_FAILED'));
            }
            else if (text.includes('invalid extension')) {
                failedReasons.push(getIn18Text('INVALID_EXTENSION'));
            }
            else if (text.trim().length > 0) {
                failedReasons.push(getIn18Text(text));
            }
            else {
                failedReasons.push(getIn18Text('QITAYUANYIN'));
            }
        };
        importResult.forEach(res => {
            if (res.success) {
                successCount++;
            }
            else {
                failedCount++;
                if ((res === null || res === void 0 ? void 0 : res.reason) !== 'canceled') {
                    pushReason(res === null || res === void 0 ? void 0 : res.reason);
                }
            }
        });
        const reasonText = Array.from(new Set(failedReasons)).join('、');
        hideLoading && hideLoading();
        const al = Alert.info({
            title: getIn18Text('DAORUYOUJIANWANCHENG'),
            content: (React.createElement("div", null,
                React.createElement("p", null, `${getIn18Text('DAORUCHENGGONG')} ${successCount} ${getIn18Text('FENGMAIL')}, ${getIn18Text('FAILED')} ${failedCount} ${getIn18Text('FENGMAIL')}`),
                failedCount > 0 ? React.createElement("p", { style: { color: 'red' } }, `${getIn18Text('SHIBAIYUANYIN')}：${reasonText}`) : '')),
            funcBtns: [
                {
                    text: getIn18Text('ZHIDAOLE'),
                    type: 'primary',
                    onClick: () => {
                        al.destroy();
                    },
                },
            ],
        });
    });
};
export const systemIsWindow = () => {
    try {
        return /windows\s*(?:nt)?\s*[._\d]*/i.test(navigator.userAgent);
    }
    catch (e) {
        console.error('[Error systemIsWindow]', e);
    }
};
export const systemIsMac = () => {
    try {
        return /mac os x/i.test(navigator.userAgent);
    }
    catch (e) {
        console.error('[Error systemIsWindow]', e);
    }
};
export const getChooseMailId = (mailIdList, store, type) => {
    var _a, _b;
    if (mailIdList && mailIdList.length) {
        if (type == MAIL_LIST_CHOOSE_TYPE.EMPTY) {
            return [];
        }
        const res = [];
        for (let i = 0; i < mailIdList.length; i++) {
            const mailId = mailIdList[i];
            const mail = store[mailId];
            if (mail) {
                if (type == MAIL_LIST_CHOOSE_TYPE.ALL) {
                    res.push(mail);
                }
                if (type == MAIL_LIST_CHOOSE_TYPE.UNREAD && ((_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.readStatus) === 'unread') {
                    res.push(mail);
                }
                if (type == MAIL_LIST_CHOOSE_TYPE.READ && ((_b = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _b === void 0 ? void 0 : _b.readStatus) === 'read') {
                    res.push(mail);
                }
            }
        }
        return res
            .filter(item => {
            var _a;
            return ((_a = item === null || item === void 0 ? void 0 : item.taskInfo) === null || _a === void 0 ? void 0 : _a.status) !== TASK_MAIL_STATUS.PROCESSING;
        })
            .map(item => { var _a; return (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.id; });
    }
    return [];
};
let mailAliasArrCache = null;
export const getMailAliasArr = () => {
    const accountAlias = systemApi.getCurrentUserAccountAlias();
    if (accountAlias && accountAlias.length > 0) {
        return Promise.resolve(accountAlias);
    }
    if (mailAliasArrCache && mailAliasArrCache.length) {
        return Promise.resolve(mailAliasArrCache || []);
    }
    return mailConfApi
        .getMailSenderInfo()
        .then(res => {
        if (res && res.length) {
            return res.map(item => {
                return item.id;
            });
        }
        return [];
    })
        .then(arr => {
        mailAliasArrCache = arr;
        return mailAliasArrCache;
    });
};
export const getMailFromMails = (mails) => {
    return Array.isArray(mails) ? mails[0] : mails;
};
export const handleBackEnd = async (params) => {
    var _a;
    const { anchor, payform, queryString } = params || {};
    const redirectUrl = `${mailConfApi.getWebMailHost(true)}/admin/login.do?hl=zh_CN&uid=${(_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id}&app=admin&all_secure=1${payform ? '&payform=' + payform : ''}${anchor ? '&anchor=' + anchor : ''}${queryString ? queryString : ''}`;
    const url = await mailConfApi.getWebSettingUrlInLocal('', { url: redirectUrl });
    if (url && url.length > 0) {
        systemApi.openNewWindow(url, false, undefined, undefined, true);
    }
    else {
        Toast.warn({
            content: getIn18Text('WUFADAKAIZHI'),
            duration: 3,
        });
    }
};
export const handleBackEndPaid = ({ source }) => {
    handleBackEnd({
        anchor: '/orderDispatch',
        payform: inElectron ? 'LX_DESKTOP' : 'LX_WEB',
        queryString: '&orderOnly=true&source=' + source,
    });
};
export const urlHasJavascriptProtocol = (link) => {
    try {
        const javascriptRegex = /^\s*(javascript:|https?:\/\/javascript:;)/i;
        return javascriptRegex.test(link);
    }
    catch (e) {
        console.error('[Error urlHasJavascriptProtocol]', e);
    }
    return false;
};
const deleteReactKey = ['ref', 'key', 'children', 'className', 'style', 'dangerouslySetInnerHTML', 'htmlFor'];
export const filterReactProps = (obj) => {
    let res = {};
    try {
        res = Object.assign({}, obj);
        if (deleteReactKey === null || deleteReactKey === void 0 ? void 0 : deleteReactKey.length) {
            for (let i = 0; i < deleteReactKey.length; i++) {
                if (res[deleteReactKey[i]]) {
                    delete res[deleteReactKey[i]];
                }
            }
        }
    }
    catch (e) {
        console.error('[filterReactProps error]', e);
    }
    return res;
};
export const trans2DomPropsObj = (domProps, mails, menuConfig) => {
    let res = {};
    try {
        if (domProps) {
            if (typeof domProps == 'function') {
                const fnRes = domProps(mails, menuConfig);
                if (typeof fnRes == 'object') {
                    res = fnRes;
                }
            }
            else if (typeof domProps == 'object') {
                res = domProps;
            }
        }
    }
    catch (e) {
        console.error('[error trans2DomPropsObj]', e);
    }
    return filterReactProps(res);
};
export const formatHotKey = (hotKey) => {
    if (hotKey) {
        const command = util.getCommonTxt();
        const showKey = {
            command: command,
            shift: isMac() ? '⇧' : 'Shift',
            alt: isMac() ? '⌥' : 'Alt',
            ctrl: isMac() ? '⌃' : 'Ctrl',
            enter: isMac() ? '↩' : 'Enter',
            up: '↑',
            down: '↓',
            del: '⌫',
        };
        return hotKey.map(item => showKey[item.toLowerCase()] || item).join('+');
    }
    return '';
};
export const isTextShortcut = (event) => {
    var textShortcuts = ['c', 'v', 'x', 'z', 'y', 'a', 'f', 'h', 'p'];
    var keyName = isMac() ? 'metaKey' : 'ctrlKey';
    if (event[keyName]) {
        if (event.key && textShortcuts.includes(event.key.toLocaleLowerCase())) {
            return true;
        }
    }
    return false;
};
const tryImg = (url, curTime, resolve, reject, imgEle, st) => {
    if (!imgEle)
        reject();
    try {
        if (curTime > 2) {
            reject();
        }
        else {
            const targetUrl = url + `&tryTime=${curTime}`;
            imgEle.onload = () => {
                resolve(targetUrl);
            };
            imgEle.onerror = () => {
                st = setTimeout(() => {
                    tryImg(url, curTime + 1, resolve, reject, imgEle, st);
                }, 200);
            };
            imgEle.src = targetUrl;
        }
    }
    catch (e) {
        console.error('[tryImg error]', e);
        reject();
    }
};
const loopTryImg = (url, imgEle, st) => {
    return new Promise((resolve, reject) => {
        tryImg(url, 0, resolve, reject, imgEle, st);
    });
};
export const getUseableImg = async (url, imgEle) => {
    try {
        let st = null;
        const res = await loopTryImg(url, imgEle, st);
        st && clearTimeout(st);
        if (res) {
            return res;
        }
        return '';
    }
    catch (error) {
        return '';
    }
};
export const getFixedMailHead = () => {
    var _a;
    try {
        return !!((_a = storeApi.getSync(PIN_KEY, { noneUserRelated: true })) === null || _a === void 0 ? void 0 : _a.data);
    }
    catch (e) {
        console.error('[getFixedMailHead error]', e);
    }
    return false;
};
export const simpleHash = (params) => {
    let hash = 0;
    try {
        const str = JSON.stringify(params);
        if (str === undefined || str.length == 0)
            return `${hash}`;
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash;
        }
    }
    catch (e) {
        console.error('[simpleHash error]', e);
    }
    return `${hash}`;
};
export const createLangKey = (from, to) => {
    return `${from}&&&${to}`;
};
export const parseLangKey = (langKey) => {
    const arr = langKey.split('&&&');
    if (arr.length >= 2) {
        const from = arr[0];
        const to = arr[1];
        return {
            from,
            to,
        };
    }
    if (arr.length === 1) {
        return {
            from: undefined,
            to: arr[0],
        };
    }
    return {
        from: undefined,
        to: undefined,
    };
};
export const isTranslateSuccess = (content) => {
    var _a;
    const langType = (_a = content === null || content === void 0 ? void 0 : content.entry) === null || _a === void 0 ? void 0 : _a.langType;
    if (!langType) {
        return false;
    }
    if (langType === 'origin') {
        return false;
    }
    return true;
};
export const transTag2Name = (tag) => {
    if (tag && MAIL_TAG_SYSTEM_MAP[tag]) {
        return MAIL_TAG_SYSTEM_MAP[tag];
    }
    return tag;
};
export const isLockTag = (tag) => {
    return !!MAIL_TAG_SYSTEM_MAP[tag];
};
export const getQueryParamsByVirtualTag = (tag) => {
    return MAIL_TAG_QUERY_MAP[tag];
};
export const transTag2VirtualTag = (mail, tags) => {
    var _a, _b, _c;
    if ((_b = (_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.systemLabel) === null || _b === void 0 ? void 0 : _b.length) {
        const systemLabel = (_c = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _c === void 0 ? void 0 : _c.systemLabel;
        if (systemLabel.includes(3)) {
            tags.unshift([QUERY2MAIL_TAG_MAP[3], { color: 8, show: 1 }, 0, 0, 0, 0, 0, 0]);
        }
        if (systemLabel.includes(4)) {
            tags.unshift([QUERY2MAIL_TAG_MAP[4], { color: 5, show: 1 }, 0, 0, 0, 0, 0, 0]);
        }
    }
};
export const getWmGuideSortFoldeIds = (folderList) => {
    let sysFolders = folderList.filter(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxType) === 'sys'; });
    const topFolderId = [FLOLDER.DEFAULT, FLOLDER.UNREAD, FLOLDER.EDM_REPLY, FLOLDER.EDM_OTHER_REPLY, FLOLDER.SENT, FLOLDER.CUSTOMER_UNFOLLOW, FLOLDER.UNFOLLOW];
    const topFolder = [];
    const bottomFolder = [];
    topFolderId.forEach(item => {
        const res = sysFolders.find(folder => folder.entry.mailBoxId == item);
        if (res) {
            topFolder.push(res);
        }
    });
    sysFolders.forEach(item => {
        let numberId = item.mailBoxId;
        try {
            numberId = parseInt(numberId);
        }
        catch (e) {
            console.error('[getWmGuideSortFoldeIds error]', e);
        }
        if (!topFolderId.includes(numberId)) {
            bottomFolder.push(item);
        }
    });
    return [...topFolder, ...bottomFolder].map(item => {
        return item.entry.mailBoxId;
    });
};
export const is90DaysAgo = (mail) => {
    try {
        const receiveTime = mail.entry.receiveTime || mail.entry.sendTime || '';
        const now = new Date().getTime();
        const createTimeStamp = new Date(receiveTime).getTime();
        const diff = now - createTimeStamp;
        const diffDays = Math.floor(diff / (1000 * 60 * 60 * 24));
        return diffDays > 90;
    }
    catch (e) {
        console.error('[is90DaysAgo error]', e);
    }
    return false;
};
export const escapeHtmlExceptB = (text) => {
    try {
        if (typeof text !== 'string') {
            return '';
        }
        let escaped = text.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
        escaped = escaped.replace(/&lt;b&gt;/g, '<b>').replace(/&lt;\/b&gt;/g, '</b>');
        return escaped;
    }
    catch (e) {
        console.log(e);
        return text;
    }
};
